import { Routes } from '@angular/router';
import { routes as apisRoutes } from './apis/apis.routes';
import { databaseResolverFn } from './databases/resolvers/database.resolver';
import { entityResolverFn } from './databases/resolvers/entity.resolver';
import { schemaResolverFn } from './databases/resolvers/schema.resolver';
import { bpmnResolverFn } from './bpmn/resolvers/bpmn.resolver';

export const routes: Routes = [
	{
		path: '',
		data: { breadcrumb: 'DATA_SOURCES.BREADCRUMBS.MAIN' },
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./source-wrapper/data-sources-wrapper.component').then(
						(component) => component.DataSourcesWrapperComponent
					),
				children: [
					{
						path: '',
						redirectTo: 'databases',
						pathMatch: 'full'
					},
					{
						path: 'databases',
						data: { breadcrumb: 'DATABASE_LIST.BREADCRUMBS.MAIN' },
						loadComponent: () =>
							import(
								'./databases/components/database-list/database-list.component'
							).then((c) => c.DatabaseListComponent)
					},
					{
						path: 'apis',
						data: { breadcrumb: 'API_LIST.BREADCRUMBS.MAIN' },
						loadComponent: () =>
							import('./apis/components/api-list/api-list.component').then(
								(c) => c.ApiListComponent
							)
					},
					{
						path: 'bpmn',
						data: { breadcrumb: 'BPMN_LIST.BREADCRUMBS.MAIN' },
						loadComponent: () =>
							import('./bpmn/components/bpmn-list/bpmn-list.component').then(
								(c) => c.BpmnListComponent
							)
					}
				]
			},
			{
				path: '',
				data: { breadcrumb: 'DATABASE_LIST.BREADCRUMBS.MAIN' },
				children: [
					{
						path: 'databases/add',
						data: { breadcrumb: 'DATABASE_EDITION.BREADCRUMBS.ADD' },
						loadComponent: () =>
							import(
								'./databases/components/database-edition/database-edition.component'
							).then((component) => component.DatabaseEditionComponent)
					},
					{
						path: 'databases/:databaseId',
						resolve: { value: databaseResolverFn },
						data: {
							breadcrumb: (data: any) =>
								data.value?.name || 'DATABASE_EDITION.BREADCRUMBS.EDIT'
						},
						children: [
							{
								path: '',
								loadComponent: () =>
									import(
										'./databases/components/database-edition/database-edition.component'
									).then((component) => component.DatabaseEditionComponent)
							},
							{
								path: 'schemas',
								data: {
									breadcrumb: 'DATABASES.TITLES.BREADCRUMB_SCHEMAS'
								},
								children: [
									{
										path: '',
										loadComponent: () =>
											import(
												'./databases/components/schema-list/schema-list.component'
											).then((component) => component.SchemaListComponent)
									},
									{
										path: ':schemaId',
										resolve: { schema: schemaResolverFn },
										data: {
											breadcrumb: (data: any) => data.schema?.name
										},
										children: [
											{
												path: '',
												loadComponent: () =>
													import(
														'./databases/components/schema-edition/schema-edition.component'
													).then(
														(component) => component.SchemaEditionComponent
													)
											},
											{
												path: 'map',
												data: {
													breadcrumb: 'DATABASES.TITLES.BREADCRUMB_MAP',
													nonNavigable: true
												},
												loadComponent: () =>
													import(
														'./databases/components/schema-map/schema-map.component'
													).then((component) => component.SchemaMapComponent)
											},
											{
												path: 'entities',
												children: [
													{
														path: '',
														data: { breadcrumb: 'ENTITIES.TITLES.BREADCRUMB' },
														children: [
															{
																path: '',
																loadComponent: () =>
																	import(
																		'./databases/components/entity-list/entity-list.component'
																	).then(
																		(component) => component.EntityListComponent
																	)
															},
															{
																path: ':entityId',
																resolve: { entity: entityResolverFn },
																data: {
																	breadcrumb: (data: any) => data.entity?.name
																},
																children: [
																	{
																		path: '',
																		loadComponent: () =>
																			import(
																				'./databases/components/entity-edition/entity-edition.component'
																			).then(
																				(component) =>
																					component.EntityEditionComponent
																			)
																	},
																	{
																		path: 'fields',
																		data: {
																			breadcrumb:
																				'DATABASES.TITLES.BREADCRUMB_FIELDS'
																		},
																		loadComponent: () =>
																			import(
																				'./databases/components/field-list/field-list.component'
																			).then(
																				(component) =>
																					component.FieldListComponent
																			)
																	},
																	{
																		path: 'relationships',
																		data: {
																			breadcrumb:
																				'RELATIONSHIPS.TITLES.BREADCRUMB',
																			nonNavigable: false
																		},
																		loadComponent: () =>
																			import(
																				'./databases/components/relationship-list/relationship-list.component'
																			).then(
																				(component) =>
																					component.RelationshipListComponent
																			)
																	}
																]
															}
														]
													}
												]
											},
											{
												path: 'relationships',
												data: {
													breadcrumb: 'RELATIONSHIPS.TITLES.BREADCRUMB',
													nonNavigable: false
												},
												loadComponent: () =>
													import(
														'./databases/components/relationship-list/relationship-list.component'
													).then(
														(component) => component.RelationshipListComponent
													)
											}
										]
									}
								]
							}
						]
					}
				]
			},
			// Routes outside the wrapper for database management

			// Routes outside the wrapper for API management
			{
				path: 'apis',
				children: apisRoutes
			},
			// Routes outside the wrapper for BPMN management
			{
				path: 'bpmn',
				children: [
					{
						path: 'add',
						data: { breadcrumb: 'BPMN_EDITION.BREADCRUMBS.ADD' },
						loadComponent: () =>
							import(
								'./bpmn/components/bpmn-edition/bpmn-edition.component'
							).then((c) => c.BpmnEditionComponent)
					},
					{
						path: ':bpmnId',
						resolve: { value: bpmnResolverFn },
						data: {
							breadcrumb: (data: any) =>
								data.value?.name || 'BPMN_EDITION.BREADCRUMBS.EDIT'
						},
						loadComponent: () =>
							import(
								'./bpmn/components/bpmn-edition/bpmn-edition.component'
							).then((c) => c.BpmnEditionComponent)
					}
				]
			}
		]
	}
];
